import { SxProps } from "@mui/material";

export const commonColumnStyles: SxProps = {
  width: "90%",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
};

export const actionColumnStyles: SxProps = {
  minWidth: "34px",
  minHeight: "34px",
  padding: 0,
};
